import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	bodyContainer: {
		padding: theme.spacing(2)
	},
	footerContainer: {
		padding: theme.spacing(1, 2),
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		borderRadius: theme.spacing(0, 0, 0.5, 0.5)
	},
	footerText: {
		color: colors.gray[300]
	},
	popper: {
		zIndex: 99999
	},
	textContainer: {
		minHeight: 48,
		maxHeight: 180,
		overflowY: "auto"
	},
	actionButton: {
		padding: theme.spacing(2),
		height: 20
	},
	secondaryTitleText: {
		color: colors.getPrimaryColor(),
		fontWeight: 500,
		fontSize: 12,
		lineHeight: "19px"
	}
}))

export default useStyles
